import { createBrowserRouter, Navigate } from 'react-router-dom'

import { ContextProvider } from '../context/common/ContextProvider'
import SettingsProvider from '../context/settings/SettingsProvider'
import Calendar from '../pages/Calendar'
import LoginPage from '../pages/common/Login'
import Customers from '../pages/Customers'
import CustomerBookings from '../pages/customers/Bookings'
import MonthlyOverview from '../pages/MonthlyOverview'
import SettingsCalendar from '../pages/settings/Calendar'
import DashboardSettings from '../pages/settings/Dashboard'
import Emails from '../pages/settings/Emails'
import Employees from '../pages/settings/Employees'
import ExternalApi from '../pages/settings/ExternalApi'
import MailServer from '../pages/settings/MailServer'
import Notifications from '../pages/settings/Notifications'
import Restaurant from '../pages/settings/Restaurant'
import Rooms from '../pages/settings/Rooms'
import Service from '../pages/settings/Service'
import ServiceCategory from '../pages/settings/ServiceCategory'
import Services from '../pages/settings/Services'
import Shifts from '../pages/settings/Shifts'
import Tenant from '../pages/settings/Tenant'
import Theme from '../pages/settings/Theme'
import User from '../pages/settings/User'

import Dashboard from '@/pages/Dashboard'
import Features from '@/pages/settings/Features'
import Requests from '@/pages/Requests'

export const routes = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: <ContextProvider />,
    errorElement: <Navigate to="/" />,
    children: [
      {
        index: true,
        element: <Navigate to="dashboard" />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'requests',
        element: <Requests />,
      },
      {
        path: 'calendar',
        element: <Calendar />,
      },
      {
        path: 'monthly-overview',
        element: <MonthlyOverview />,
      },
      {
        path: 'customers',
        element: <Customers />,
      },
      {
        path: 'customers/:customerId/bookings',
        element: <CustomerBookings />,
      },
      {
        path: 'settings',
        element: <SettingsProvider />,
        children: [
          {
            path: 'user',
            index: true,
            element: <User />,
          },
          {
            path: 'features',
            element: <Features />,
          },
          {
            path: 'tenant',
            element: <Tenant />,
          },
          {
            path: 'restaurant',
            element: <Restaurant />,
          },
          {
            path: 'service',
            element: <Service />,
          },
          {
            path: 'dashboard-settings',
            element: <DashboardSettings />,
          },
          {
            path: 'calendar-settings',
            element: <SettingsCalendar />,
          },
          {
            path: 'shifts',
            element: <Shifts />,
          },
          {
            path: 'rooms',
            element: <Rooms />,
          },
          {
            path: 'employees',
            element: <Employees />,
          },
          {
            path: 'services',
            element: <Services />,
          },
          {
            path: 'categories',
            element: <ServiceCategory />,
          },
          {
            path: 'theme',
            element: <Theme />,
          },
          {
            path: 'notifications',
            element: <Notifications />,
          },
          {
            path: 'emails',
            element: <Emails />,
          },
          {
            path: 'external-api',
            element: <ExternalApi />,
          },
          {
            path: 'mail-server',
            element: <MailServer />,
          },
        ],
      },
    ],
  },
])
